function shiftOne(prev, next, rtn, isNext) {
  const i = isNext ? next.shift() : prev.shift();

  if (i) {
    return shiftOne(prev, next, rtn.concat(i), !isNext);
  } else if (isNext) {
    return rtn.concat(prev);
  }
  return rtn.concat(next);
}

// Take an array like [1,2,3,4,5,6,7,8,9] and fan out from an index i.e.
// that array from its 3rd element would result in [3,4,2,5,1,6,7,8,9]
export default function fanOutFromIndex(array, index = 0) {
  const prev = array.slice(0, index).reverse();
  const next = array.slice(index + 1);
  const result = [array[index]];

  return shiftOne(prev, next, result, true);
}
